module.exports = __webpack_public_path__ + "img/promo@2x.64d868a6.png";